import {
  getMetaImageUrl,
  IMAGE_HEIGHT,
  IMAGE_WIDTH,
} from '../../lib/sanity/imageUrlUtils';
import { Sanity$Image } from '../../types/sanityImage';
import { Sanity$Meta, Sanity$TextBlock } from '../../types/sanityTypes';
import Head from '../Head/Head';
import blocksToString from './blocksToString';

type Props = {
  meta?: Omit<Sanity$Meta, '_type'>;
  defaultTags: {
    title: string | Array<Sanity$TextBlock>;
    description: string | Array<Sanity$TextBlock>;
    image?: Sanity$Image;
  };
};

const MetaTags = ({ meta, defaultTags }: Props) => {
  const isPreview = process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview';
  const fallbackTitle = Array.isArray(defaultTags.title)
    ? blocksToString(defaultTags.title)
    : defaultTags.title;
  const fallbackDescription = Array.isArray(defaultTags.description)
    ? blocksToString(defaultTags.description)
    : defaultTags.description;

  const imageUrl = getMetaImageUrl(meta?.metaImage || defaultTags?.image);

  return (
    <Head
      title={meta?.metaTitle || fallbackTitle}
      description={meta?.metaDescription || fallbackDescription}
      noindex={meta?.noindex || isPreview}
      canonicalURLOverride={meta?.canonicalURLOverride || null}
      image={imageUrl || undefined}
      imageWidth={IMAGE_WIDTH || undefined}
      imageHeight={IMAGE_HEIGHT || undefined}
    />
  );
};

export default MetaTags;
